import { apiService } from './apiService';
import { IProviderStatisticsResponse } from '../../share/types/provider';
import { ICaseCenter } from 'src/share/services/cases';
import { CaseTypes } from 'src/share/types/case/case';
import { IntervalTypes } from '../utils/intervals';

export enum StatsTypes {
  ALERTINSIGHTS = 'alertInsights',
  CASES = 'cases',
  ALERTS = 'alerts',
  PROVIDERS = 'providers',
  MATCHES = 'matches',
  GEOSEARCH = 'geosearch',
  GLOBALDASHBOARD = 'globalDashboard',
}

export interface IStatisticsFilters {
  agencyCode?: string;
  status?: string;
  caseType?: string;
  range?: { lte: number; gte: number };
  provider?: string;
  state?: string;
  alertId?: string;
  date?: number;
}

export const StatisticsService = {
  getStats: async (type: StatsTypes, filters: IStatisticsFilters) => {
    return apiService
      .post('/api/statistics', { type, ...filters })
      .then((res) => {
        const { data } = res;
        return res.status === 200 && data;
      });
  },
  getCasesCenter: (
    agencyCode: string,
    status?: 'ALL' | 'open' | 'closed',
    caseType?: CaseTypes | 'ALL',
    state?: string,
    range?: { lte: number; gte: number }
  ): Promise<ICaseCenter[]> => {
    return apiService
      .post('/api/statistics/center', {
        request: { agencyCode, status, caseType, state, range },
      })
      .then((res) => {
        const { data } = res;
        if (res.status === 200 && data.casesCenter) {
          return data.casesCenter as ICaseCenter[];
        }
        return [];
      });
  },
  getMonthlyHighlights: (
    agencyCode: string,
    status?: 'ALL' | 'open' | 'closed',
    caseType?: CaseTypes | 'ALL',
    range?: { lte: number; gte: number }
  ) => {
    return apiService
      .post('/api/statistics/monthlyHighlights', {
        agencyCode,
        status,
        caseType,
        range,
      })
      .then((res) => {
        const { data } = res;
        return res.status === 200 && data;
      });
  },
  getProvidersStats: async (type: StatsTypes, interval: IntervalTypes) => {
    return apiService
      .post('/api/statistics/providers', { type, interval })
      .then((res) => {
        return res.data as IProviderStatisticsResponse;
      });
  },
};



// WEBPACK FOOTER //
// ./src/share/services/statistics.ts